<h1>{{ ("reports" | i18n) || "Berichte" | titlecase }}</h1>
<div class="reports">
  <div class="row">
    <div class="col col-md-6">
      <mat-form-field>
        <mat-label>{{ ("from" | i18n) || "from" | titlecase }} </mat-label>
        <input
          matInput
          [value]="(fromParam$ | async) ? (fromParam$ | async | date) : ''"
          readonly
          (click)="fromDatePicker.open()"
          data-cy="reports-from-date-input" />
        <input
          matInput
          name="fromDatePicker"
          [value]="fromDate$ | async"
          (dateChange)="selectFromDate($event)"
          (click)="fromDatePicker.open()"
          (keydown)="(false)"
          [matDatepicker]="fromDatePicker"
          [min]="dynamicMinFromDate"
          hidden />
        <mat-datepicker-toggle
          matSuffix
          [for]="fromDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #fromDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col col-md-6">
      <mat-form-field>
        <mat-label>{{ ("to" | i18n) || "to" | titlecase }}</mat-label>
        <input
          matInput
          [value]="(toParam$ | async) ? (toParam$ | async | date) : ''"
          readonly
          (click)="toDatePicker.open()"
          data-cy="reports-to-date-input" />
        <input
          matInput
          name="toDatePicker"
          [value]="toDate$ | async"
          (dateChange)="selectToDate($event)"
          (click)="toDatePicker.open()"
          (keydown)="(false)"
          [matDatepicker]="toDatePicker"
          [max]="dynamicMaxToDate"
          hidden />
        <mat-datepicker-toggle
          matSuffix
          [for]="toDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #toDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col col-md-6">
      <app-department-select
        (departmentsSelectionChanged)="selectDepartments($event)"
        [isMultiSelect]="true"
        [selectedDepartmentIds]="(selectedDepartmentIds$ | async) || []"
        data-cy="reports-department-select"></app-department-select>
    </div>
    <div class="col col-md-6">
      <app-certificate-select
        [selectedCertificates]="(selectedCertificates$ | async) || []"
        (selectionChanged)="selectCertificates($event)">
      </app-certificate-select>
    </div>
    <div class="col col-md-6">
      <!--      <mat-form-field *ngIf="i18n && displayJobTypeFilter">-->
      <!--        <mat-label>-->
      <!--          {{ ('jobType' | i18n) || "Jobtype" | titlecase}}-->
      <!--        </mat-label>-->
      <!--        <mat-select-->
      <!--          [(ngModel)]="selectedJobType"-->
      <!--          name="jobTypeSelect"-->
      <!--          data-cy="job-type-select">-->
      <!--          <mat-option [value]="undefined"> - </mat-option>-->
      <!--          <mat-option-->
      <!--            *ngFor="let jobType of jobTypeEnum | enumToArray"-->
      <!--            [value]="jobTypeEnum[jobType]">-->
      <!--            {{ (('jobTypeEnum.' + jobTypeEnum[jobType]) | i18n) || jobType}}-->
      <!--          </mat-option>-->
      <!--        </mat-select>-->
      <!--      </mat-form-field>-->
      <app-pooler-type-select
        *ngIf="displayPoolerTypeFilter"
        [ngModel]="poolerTypeParam$ | async"
        (ngModelChange)="selectPoolerType($event)"
        name="poolerTypeSelect"
        data-cy="reports-index-pooler-type-select">
      </app-pooler-type-select>
    </div>
    <div
      class="col col-md-6"
      *ngIf="displayCustomerFilter$ | async">
      <app-customer-select
        [useQueryParam]="'customers'"
        [includeTransferCustomers]="true"
        data-cy="reports-customer-select">
      </app-customer-select>
    </div>
  </div>
  <div
    *ngIf="isLoading"
    class="d-flex justify-content-center align-items-center"
    data-cy="reports-loading-spinner">
    <mat-spinner diameter="30"></mat-spinner>
    <span class="ms-2">{{ ("loadingReport" | i18n) || "Loading report" }}</span>
  </div>
  <div class="row mt-3">
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayJobsForInvoiceReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.JOBS_FOR_INVOICE)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.JOBS_FOR_INVOICE | i18n) ||
            "Dienste für Rechnung"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("jobsForInvoiceDescription" | i18n) ||
                "Liste aller Dienste für die Rechnung"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadJobsForInvoiceReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            CSV
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayCurrentlyActiveEmploymentsReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(
          reportsEnum.CURRENTLY_ACTIVE_EMPLOYMENTS
        )
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.CURRENTLY_ACTIVE_EMPLOYMENTS | i18n) ||
            "Laufende Temporär-Einsätze"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("currentlyActiveEmploymentsDescription" | i18n) ||
                "Eine Liste aller für den gewählten Zeitraum gebuchten Temporär-Einsätze mit Einsatzort und Pensum"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadCurrentlyActiveEmploymentsReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            EXCEL
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayExternalCancellationsReport$ | async) &&
        (currentCustomer$ | async)?.enableManualCancelTimestampForExternal &&
        !(hiddenReportIds$ | async)?.includes(
          reportsEnum.EXTERNAL_CANCELLATIONS
        )
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.EXTERNAL_CANCELLATIONS | i18n) ||
            "Absagezeitpunkt externe Mitarbeitende"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("externalCancellationsDescription" | i18n) ||
                "Übersicht aller extern abgesagten Dienste."
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            [matMenuTriggerFor]="externalCancellationsMenu"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            {{ ("download" | i18n) || "Download" }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayActivityReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.ACTIVITY)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.ACTIVITY | i18n) || "Inaktivität"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("activityReportDescription" | i18n) ||
                "Liste aller Pooler, welche für den gewählten Zeitraum inaktiv waren"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions class="wrapping-card-actions">
          <button
            mat-stroked-button
            type="button"
            (click)="downloadAvailabilityInactivityReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            {{ ("noAvailabilities" | i18n) || "Keine Verfügbarkeit" }}
          </button>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadWorkingInactivityReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            {{ ("noBookings" | i18n) || "Keine Buchungen" }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayActivityReport$ | async) &&
        displayTimeTrackingReport &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.TIME_TRACKING)
      ">
      <mat-card
        class="reports__report-card"
        data-cy="time-tracking-report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.TIME_TRACKING | i18n) ||
            "Stundenrapport"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("timeTrackingReportDescription" | i18n) ||
                "Export der erfassten Arbeitszeit pro geleistetem Dienst"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            [matMenuTriggerFor]="timeTrackingReportMenuCsv"
            [disabled]="isLoading || !(hasValidDateRange$ | async)"
            data-cy="time-tracking-report-download-csv-button">
            <mat-icon svgIcon="download"></mat-icon>
            {{ ("csv" | i18n) || "CSV" }}
          </button>
          <button
            mat-stroked-button
            type="button"
            [matMenuTriggerFor]="timeTrackingReportMenuXls"
            [disabled]="isLoading || !(hasValidDateRange$ | async)"
            data-cy="time-tracking-report-download-xlsx-button">
            <mat-icon svgIcon="download"></mat-icon>
            {{ ("excel" | i18n) || "Excel" }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayShiftsPlanningReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.SHIFTS_PLANNING)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.SHIFTS_PLANNING | i18n) ||
            "Dienstplanung"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("shiftsPlanningReportDescription" | i18n) ||
                "Liste aller Einsätze für den gewählten Zeitraum"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadShiftPlanningReportPerPooler()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            {{ ("perPooler" | i18n) || "Pro pooler" }} (CSV)
          </button>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadShiftPlanningReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            CSV
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayJobOverviewReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.JOB_OVERVIEW)
      ">
      <mat-card
        class="reports__report-card"
        data-cy="job-overview-report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.JOB_OVERVIEW | i18n) ||
            "Dienstübersicht"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("jobOverviewReportDescription" | i18n) ||
                "Enthält alle Dienste mit allen Status für den gewählten Zeitraum"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadJobOverviewReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            EXCEL
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayDisponentOverviewReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.DISPONENT_OVERVIEW)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.DISPONENT_OVERVIEW | i18n) ||
            "Disponenten Übersicht"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("disponentAssignmentReportDescription" | i18n) ||
                "Übersicht über alle Disponenten und ihre Berechtigungen"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadDisponentAssignmentReport()"
            [disabled]="isLoading">
            <mat-icon svgIcon="download"></mat-icon>
            CSV
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayRequesterOverviewReport$ | async) &&
        (currentCustomer$ | async)?.enableJobRequestProcess &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.REQUESTER_OVERVIEW)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.REQUESTER_OVERVIEW | i18n) ||
            "Besteller Übersicht"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("requesterAssignmentReportDescription" | i18n) ||
                "Übersicht über alle Besteller und ihre Berechtigungen"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadRequesterAssignmentReport()"
            [disabled]="isLoading">
            <mat-icon svgIcon="download"></mat-icon>
            CSV
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayPoolerOverviewReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.POOLER_OVERVIEW)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.POOLER_OVERVIEW | i18n) ||
            "Pooler Übersicht"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("poolerAssignmentReportDescription" | i18n) ||
                "Zuordnung der Pooler pro Klinik / Abteilung inkl.Ausbildung und Zusatzausbildung"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions class="wrapping-card-actions">
          <button
            mat-stroked-button
            type="button"
            (click)="downloadPoolerAssignmentReport(true)"
            [disabled]="isLoading">
            <mat-icon svgIcon="download"></mat-icon>
            {{ ("perPooler" | i18n) || "Pro pooler" }} (CSV)
          </button>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadPoolerAssignmentReport()"
            [disabled]="isLoading">
            <mat-icon svgIcon="download"></mat-icon>
            {{ ("perDepartment" | i18n) || "Pro abteilung" }} (CSV)
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayAvailableUserJobPlanningReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(
          reportsEnum.AVAILABLE_USER_JOB_PLANNING
        )
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.AVAILABLE_USER_JOB_PLANNING | i18n) ||
            "Mitarbeiter Planung"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("availableUserJobPlanningDescription" | i18n) ||
                "Übersicht aller Zusagen für alle offenen Dienste"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadAvailableUserJobPlanningReport()"
            [disabled]="isLoading">
            <mat-icon svgIcon="download"></mat-icon>
            CSV
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayPoolerReactionTimeReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.POOLER_REACTION_TIME)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.POOLER_REACTION_TIME | i18n) ||
            "Mitarbeiter Reaktionszeit"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("poolerReactionTimeDescription" | i18n) ||
                "Übersicht aller Mitarbeiter und deren Reaktionszeiten."
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadPoolerReactionTimeReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            CSV
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displaySmsUsageReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.SMS_USAGE)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.SMS_USAGE | i18n) || "SMS Nutzung"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("smsUsageDescription" | i18n) ||
                "Übersicht aller versendeten Textnachrichten."
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadSmsUsageReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            CSV
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayUserAvailabilityReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.USER_AVAILABILITY)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.USER_AVAILABILITY | i18n) ||
            "Benutzer Verfügbarkeit"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("userAvailabilityReportDescription" | i18n) ||
                "Verfügbarkeiten der Benutzer"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadUserAvailabilityReport('CSV')"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            CSV
          </button>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadUserAvailabilityReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            Excel
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayArchivedJobsReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.ARCHIVED_JOBS)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.ARCHIVED_JOBS | i18n) ||
            "Archivierte Dienste und gebuchte Mitarbeiter"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("archivedJobsReportDescription" | i18n) ||
                "Alle Archivierten Dienste mit Schicht und dem gebuchten Mitarbeiter"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadCharts()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            Excel
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayArchivedJobsReport$ | async) &&
        displayTransferReport &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.TRANSFER)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.TRANSFER | i18n) || "Transfer Report"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("transferReportDescription" | i18n) ||
                "Übersicht aller Transfers."
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadTransfersReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            CSV
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayAvailabilityUpdatesReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.AVAILABILITY_UPDATES)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.AVAILABILITY_UPDATES | i18n) ||
            "Verfügbarkeiten Anpassungen"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("availabilityUpdatesReportDescription" | i18n) ||
                "Übersicht aller Änderungen der Verfügbarkeiten."
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadAvailabilityUpdatesReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            EXCEL
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayPlanningMatrixReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.PLANNING_MATRIX)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.PLANNING_MATRIX | i18n) ||
            "Planungsmatrix"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("planningMatrixReportDescription" | i18n) ||
                "Planungsmatrix zur optimalen Verteilung der buchbaren Mitarbeitenden. Hinweis: Es wird nur das 'von' Datum für diesen Report berücksichtigt"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadPlanningMatrixReport()"
            [disabled]="isLoading || !(fromParam$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            EXCEL
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayHoursByDepartmentReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.HOURS_BY_DEPARTMENT)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.HOURS_BY_DEPARTMENT | i18n) ||
            "Stunden nach Abteilung"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("hoursByDepartmentDescription" | i18n) ||
                "Übersicht der geleisteten Stunden pro Abteilung"
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadHoursByDepartmentReport()"
            [disabled]="isLoading || !(hasValidDateRange$ | async)">
            <mat-icon svgIcon="download"></mat-icon>
            EXCEL
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div
      class="col col-12 col-md-6 mb-3"
      *ngIf="
        (displayCustomerConnectionsReport$ | async) &&
        !(hiddenReportIds$ | async)?.includes(reportsEnum.CUSTOMER_CONNECTIONS)
      ">
      <mat-card class="reports__report-card">
        <mat-card-title>{{
          ("reportsEnum." + reportsEnum.CUSTOMER_CONNECTIONS | i18n) ||
            "Verbundene Kunden"
        }}</mat-card-title>
        <mat-card-content>
          <p>
            {{
              ("customerConnectionsReportDescription" | i18n) ||
                "Übersicht der Kunden welche mit Transfer oder SharedPool verbunden sind."
            }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-stroked-button
            type="button"
            (click)="downloadCustomerConnectionsReport()"
            [disabled]="isLoading">
            <mat-icon svgIcon="download"></mat-icon>
            EXCEL
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>

<mat-menu
  #timeTrackingReportMenuCsv="matMenu"
  class="fixed-icon-mat-menu"
  data-cy="time-tracking-report-menu-csv">
  <button
    mat-menu-item
    type="button"
    (click)="downloadTimeTrackingReport()"
    data-cy="time-tracking-report-csv-all">
    <mat-icon svgIcon="download"></mat-icon>
    {{ ("all" | i18n) || "Alle" | titlecase }}
  </button>
  <button
    mat-menu-item
    type="button"
    (click)="downloadTimeTrackingReportPerPooler('CSV')"
    data-cy="time-tracking-report-csv-per-pooler">
    <mat-icon svgIcon="download"></mat-icon>
    {{ ("perPooler" | i18n) || "Pro pooler" | titlecase }}
  </button>
  <button
    mat-menu-item
    type="button"
    (click)="downloadTimeTrackingReportPerOrganisation('CSV')"
    data-cy="time-tracking-report-csv-per-organisation">
    <mat-icon svgIcon="download"></mat-icon>
    {{ ("perOrganisation" | i18n) || "Pro organisation" | titlecase }}
  </button>
  <button
    mat-menu-item
    type="button"
    *ngIf="isHospitalCustomer$ | async"
    (click)="downloadTimeTrackingReportPerCustomer('CSV')"
    data-cy="time-tracking-report-csv-per-customer">
    <mat-icon svgIcon="download"></mat-icon>
    {{ "perAgency" | i18n | titlecase }}
  </button>
</mat-menu>

<mat-menu
  #timeTrackingReportMenuXls="matMenu"
  class="fixed-icon-mat-menu"
  data-cy="time-tracking-report-menu-xls">
  <button
    mat-menu-item
    type="button"
    (click)="downloadTimeTrackingReport('EXCEL')"
    data-cy="time-tracking-report-xlsx-all">
    <mat-icon svgIcon="download"></mat-icon>
    {{ ("all" | i18n) || "Alle" | titlecase }}
  </button>
  <button
    mat-menu-item
    type="button"
    (click)="downloadTimeTrackingReportPerPooler('EXCEL')"
    data-cy="time-tracking-report-xlsx-per-pooler">
    <mat-icon svgIcon="download"></mat-icon>
    {{ ("perPooler" | i18n) || "Pro pooler" | titlecase }}
  </button>
  <button
    mat-menu-item
    type="button"
    (click)="downloadTimeTrackingReportPerOrganisation('EXCEL')"
    data-cy="time-tracking-report-xlsx-per-organisation">
    <mat-icon svgIcon="download"></mat-icon>
    {{ ("perOrganisation" | i18n) || "Pro organisation" | titlecase }}
  </button>
  <button
    mat-menu-item
    type="button"
    *ngIf="isHospitalCustomer$ | async"
    (click)="downloadTimeTrackingReportPerCustomer('EXCEL')"
    data-cy="time-tracking-report-xlsx-per-customer">
    <mat-icon svgIcon="download"></mat-icon>
    {{ ("perCustomer" | i18n) || "Pro kunde" | titlecase }}
  </button>
</mat-menu>

<mat-menu #externalCancellationsMenu="matMenu">
  <button
    mat-menu-item
    (click)="downloadExternalCancellationsReport('EXCEL')"
    [disabled]="isLoading">
    <mat-icon svgIcon="download"></mat-icon>
    EXCEL
  </button>
  <button
    mat-menu-item
    (click)="downloadExternalCancellationsReport('CSV')"
    [disabled]="isLoading">
    <mat-icon svgIcon="download"></mat-icon>
    CSV
  </button>
</mat-menu>
